import { isEqual } from 'lodash';

export const computeChangedFields = (baseline: Record<string, unknown>, current: Record<string, unknown>): Record<string, unknown> => {
  const changed: Record<string, unknown> = {};

  for (const key of Object.keys(current)) {
    if (!isEqual(baseline?.[key], current[key])) {
      changed[key] = current[key];
    }
  }

  return changed;
};
